
  export default {
    mounted() {
      this.markActive();
      this._onNav = () => this.markActive();
      window.addEventListener("phx:page-loading-stop", this._onNav);
    },
    destroyed() {
      window.removeEventListener("phx:page-loading-stop", this._onNav);
    },
    markActive() {
      const path = window.location.pathname;
      const navs = Array.from(this.el.querySelectorAll("[data-nav]"));
      let best = null, bestLen = -1;
      for (const el of navs) {
        el.dataset.active = "false";
        for (const m of (el.dataset.match || "").split(" ").filter(Boolean)) {
          if ((path === m || path.startsWith(m + "/")) && m.length > bestLen) { bestLen = m.length; best = el; }
        }
      }
      if (best) best.dataset.active = "true";
    }
  }
